import { ActiveModel, ActiveField } from '@alt-point/active-models/src'
import { LoyaltyTransactionType } from './Enums'
/**
* Class ShowcaseLoyaltyTransactionDto
*  Запись ledger кошелька лояльности (append-only).
*/
export class ShowcaseLoyaltyTransactionDto extends ActiveModel {

  /**
  * id
  * ИД записи в БД<br>  */
  @ActiveField(0)
  id: number = 0


/**
  * created
  * Отметка времени создания<br>
  */
  @ActiveField('')
  created: string = ''


/**
  * updated
  * Отметка времени обновления<br>
  */
  @ActiveField('')
  updated: string = ''


/**
  * deleted
  * Отметка времени удаления<br>
  */
  @ActiveField(null)
  deleted: null | string = null


  /**
  * type
  * словарь значений публикуется под именем `Domain.Entities.Loyalty.LoyaltyTransactionType`  *   * Тип записи в ledger кошелька лояльности.  *   * - `CashbackAccrual` Начисление кэшбэка  * - `PromoAccrual` Начисление промо  * - `Redemption` Списание  * - `RedemptionHold` Холд списания  * - `RedemptionRelease` Снятие холда  * - `Expiration` Истечение  * - `StornoAccrual` Сторно начисления  * - `StornoPromoAccrual` Сторно promo-начисления  * - `ManualAdjustment` Ручная корректировка  *   */
  @ActiveField(LoyaltyTransactionType.CASHBACKACCRUAL)
  type: LoyaltyTransactionType = LoyaltyTransactionType.CASHBACKACCRUAL


  /**
  * amount
  *   */
  @ActiveField(0)
  amount: number = 0


  /**
  * balanceAfter
  *   */
  @ActiveField(0)
  balanceAfter: number = 0


  /**
  * lotId
  *   */
  @ActiveField()
  lotId?: null | number


  /**
  * orderId
  *   */
  @ActiveField()
  orderId?: null | number


/**
  * comment
  * 
  */
  @ActiveField()
  comment?: null | string
}
